export default "__VITE_ASSET__DC_82a60__"